<template>
    <div class="container-fluid">


                <div class="row">
                    <div class="col-md-4 col-12">
                        <div class="card">

                            <div class="card-body">
                                <div class="text-right">
                                    <a type="button" class="btn btn-sm px-2 btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Action</a>
                                    <div class="dropdown-menu">

                                        <a class="dropdown-item"  v-b-modal.modal-3>Edit Profile</a>
                                        <a class="dropdown-item" v-b-modal.change-phone-number >Change Phone Number</a>
                                        <a class="dropdown-item" v-b-modal.change-default-route >Set my default page</a>
                                        <a class="dropdown-item" v-b-modal.modal-2>Apply for Leave</a>
                                        <a class="dropdown-item" v-b-modal.modal-1>Apply for Salary Advance</a>
                                        <a class="dropdown-item" @click="fetchPayslipPeriods">Download Payslip</a>




                                    </div>
                                </div>

                                <div v-if="employeeProfile.avatar=== ''" class="text-center pb-3">
                                    <i class="fas fa-user-circle fa-5x"></i>
                                </div>

                                <div v-else="employeeProfile.avatar !== ''" class="text-center pb-3">
                                    <img class="img-bordered border-primary rounded-circle" :src="employeeProfile.avatar" style="width: 80px; height: 80px;" />

                                </div>

                                <h6 class="py-2 text-weight-400 text-capitalize"><span class="text-weight-700">Name: </span>{{ (employeeProfile && employeeProfile.users)? employeeProfile.users.name : ''}}</h6>
                                <h6 class="py-2 text-weight-400"><span class="text-weight-700">Joined: </span>{{FormatDate((employeeProfile && employeeProfile.users)? employeeProfile.users.created_at : '')}}</h6>
                              <h6 v-if="employeeProfile.employee_code" class="py-2 text-weight-400"><span class="text-weight-700">Employee Code: </span>{{employeeProfile.employee_code}}</h6>
                              <h6 class="py-2 text-weight-400"><span class="text-weight-700">Position: </span>{{employeeProfile.title}}</h6>
                              <h6 class="py-2 text-weight-400"><span class="text-weight-700">Phone: </span>{{(employeeProfile && employeeProfile.users) ? employeeProfile.users.phone : 'N/A'}}</h6>
                              <h6 class="py-2 text-weight-400"><span class="text-weight-700">Email: </span>{{(employeeProfile && employeeProfile.users) ? employeeProfile.users.email : 'N/A'}}</h6>
                                <h6 class="py-2 text-weight-400"><span class="text-weight-700">Role: </span>{{employeeProfile.roles}}</h6>
                                <!--<h6 class="py-2 px-2 text-weight-300 text-left"><span class="text-weight-700">Role: </span><ul class="list-inline"><li class="list-inline-item" v-for="role in employeeProfile.roles">{{role}},</li></ul></h6>-->



                            </div>

                        </div>

                    </div>
                    <div class="col-md-8 col-12">
                        <date-range-picker :auto-apply="autoApply" v-model="dateRange" class="custom-width-datepicker"
                    :ranges="false">
                    <template #input="picker" style="width: 100% !important;">
                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ FormatDate(dateRange.startDate) }}
                            - {{ FormatDate(picker.endDate) }}</p>
                        <p v-else><i class="bi bi-calendar-event"></i> Filter by Date</p>
                    </template>
                </date-range-picker>
                        <div class="row">
                            <div class="col-4  border-dark border-right">


                                    <div class="text-dark">
                                        <div class="text-center">
                                            <i class="bi bi-cash-stack" style="font-size: 1.8em"></i>
                                            <h6 class="text-font-400 text-dark py-1" v-if="employeeProfile && employeeProfile.earnings.salary" >{{convertCurrencyToShillings(employeeProfile.earnings.salary)}}</h6>
                                            <h6 class="text-font-400 text-dark py-1" v-else >0</h6>
                                            <small class="text-dark">Salary</small>

                                        </div>

                                    </div>
                                </div>
                            <div class="col-4 border-dark border-right">

                                <div class="text-dark">
                                    <div class="text-center">
                                        <i class="bi bi-graph-up" style="font-size: 1.8em"></i>
                                        <h6 class="text-font-400 text-dark py-1" v-if="employeeProfile && employeeProfile.earnings.commission" >{{convertCurrencyToShillings(employeeProfile.earnings.commission)}}</h6>
                                        <h6 class="text-font-400 text-dark py-1" v-else >0</h6>
                                        <small class="text-dark">Commission</small>

                                    </div>

                                </div>




                            </div>
                            <div class="col-4">


                                    <div class="text-dark">
                                        <div class="text-center">
                                            <i class="bi bi-cart-check-fill" style="font-size: 1.8em"></i>



                                            <h6 class="text-font-400 text-dark py-1" v-if="employeeProfile.sumOfOrders" >{{convertCurrencyToShillings(employeeProfile.sumOfOrders)}}</h6>
                                            <small class="text-dark">Total Sales value</small>
                                            <hr class="m-0" />
                                            <p class="text-font-400 text-dark py-1" > Orders made - {{this.employeeProfile.users.orders.length}}</p>



                                        </div>

                                    </div>




                            </div>
                        </div>
                        <hr/>
                        <div class="row">
                            <div class="col-4  border-dark border-right">


                                <div class="text-dark">
                                    <div class="text-center">
                                        <i class="bi bi-cash-stack" style="font-size: 1.8em"></i>
                                        <h6 class="text-font-700 text-dark py-1" v-if="employeeProfile && (employeeProfile.earnings.salary || employeeProfile.earnings.commission )" >{{convertCurrencyToShillings(employeeProfile.earnings.salary + employeeProfile.earnings.commission)}}</h6>
                                        <h6 class="text-font-400 text-dark py-1" v-else >0</h6>
                                        <small class="text-dark">Total Earnings</small>

                                    </div>

                                </div>
                            </div>
                            <div class="col-4 border-dark border-right">

                                <div class="text-dark">
                                    <div class="text-center">
                                        <i class="bi bi-graph-down" style="font-size: 1.8em"></i>

                                        <h6 class="text-font-400 text-dark py-1" v-if="employeeProfile" >{{convertCurrencyToShillings(employeeProfile.deductionSum)}}</h6>
                                        <h6 class="text-font-700 text-dark py-1" v-else >0</h6>
                                        <small class="text-dark">Total Deductions</small>
                                       <p>
                                           <!-- <a  title="View or add deductions" class="mt-5 underline-primary">View all Deductions</a> -->


                                       </p>

                                    </div>

                                </div>




                            </div>
                            <div class="col-4">


                                <div class="text-dark">
                                    <div class="text-center">
                                        <div class="text-dark">
                                            <div class="text-center">
                                                <i class="bi bi-cash-coin" style="font-size: 1.8em"></i>
                                                <h6 class="text-font-700 text-dark py-1" v-if="employeeProfile && (employeeProfile.earnings.salary || employeeProfile.earnings.commission )" >{{convertCurrencyToShillings((employeeProfile.earnings.salary + employeeProfile.earnings.commission) - employeeProfile.deductionSum)}}</h6>
                                                <h6 class="text-font-400 text-dark py-1" v-else >0</h6>
                                                <small class="text-dark">Net Earning</small>


                                            </div>

                                        </div>


                                    </div>

                                </div>




                            </div>
                        </div>




                        <div class="my-3">
                            <!--<div class="card-body">-->
                            <!--<div class="text-center text-weight-700 text-primary py-2"><h3 class="border-bottom">Attendance</h3></div>-->


                            <!--&lt;!&ndash;<line-chart :chart-data="datacollection"></line-chart>&ndash;&gt;-->

                            <!--</div>-->

                            <div v-if="employeeProfile.users.orders.length >0">
                                <div class="text-center text-weight-700 text-primary py-2"><h5 >Recent Sales</h5></div>

                                <b-table
                                        :items="orderstable.items"
                                        :fields="orderstable.fields"

                                        :per-page="orderstable.perPage"
                                        :current-page="orderstable.currentPage"
                                         sort-icon-left

                                >
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>

                                </b-table>
                                <b-pagination
                                        v-model="orderstable.currentPage"
                                        :total-rows="rowsOrders"
                                        :per-page="orderstable.perPage"

                                ></b-pagination>
                            </div>
                            <div v-else>
                                <div class=" h-100 d-flex justify-content-center align-items-center">
                                    <div class="text-center mt-5 pt-5">
                                        <img src="/images/embarrassed.png" style="width:100px;" class="img-fluid">
                                        <h6 class="text-center py-3">No recent sales </h6>
                                        <!--<a href="/orders" class="btn btn-primary" >Reload <i class="bi bi-arrow-repeat"></i></a>-->
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>



<!--start of Modals-->
<b-modal ref="payslipModal" id="modal-payslip" hide-footer hide-header>
    <h4 class="text-center text-primary">Download Payslip</h4>
    <hr />

    <div v-if="payslipData.loading" class="text-center my-3">
        <b-spinner label="Loading..."></b-spinner>
        <p>Loading payslips...</p>
    </div>

    <div v-else>
        <b-form-group label="Select Payslip Period">
            <select class="form-control" v-model="payslipData.selectedPeriod">
                <option disabled value="">-- Select a Period --</option>
                <option v-for="period in payslipData.periods" :key="period.id" :value="period.id">
                    {{ period.period }}
                </option>
            </select>
        </b-form-group>

        <div class="mt-3 text-right">
            <b-button variant="secondary" @click="$refs.payslipModal.hide()">Close</b-button>
            <b-button variant="primary" @click="downloadPayslip">Download</b-button>
        </div>
    </div>
</b-modal>

        <b-modal ref="salaryadvancemodal" id="modal-1" hide-footer hide-header static>
            <h2 class="text-center text-primary">Salary Advance Application</h2>
            <hr/>
            <form @submit.prevent="SaApply" >
                <b-form-group
                        id="input-group-1"

                        label-for="input-1"
                >
                    <b-form-input
                            id="input-1"
                            v-model=advanceform.amount
                            type="text"
                            class="border form-group"
                            placeholder="Amount eg. 1200"
                            required
                    ></b-form-input>
                    <b-form-textarea
                            id="input-1"
                            v-model=advanceform.reason
                            type="text"
                            class="border form-group"
                            placeholder="Reason for salary advance"

                            required
                    ></b-form-textarea>

                </b-form-group>
                <b-button type="submit" variant="primary" class="btn-block">Apply</b-button>

            </form>
        </b-modal>
        <b-modal ref="leavemodal" id="modal-2" hide-footer hide-header static>
            <h2 class="text-center text-primary">Leave Application</h2>
            <hr/>
            <form @submit.prevent="leaveApply" >
                <div class="datepicker-trigger">


                    <date-range-picker
                            :auto-apply="autoApply"
                            v-model="dateRange"
                            class="custom-width-datepicker"
                            :ranges="false"



                    >
                        <template #input="picker" style="width: 100% !important;">

                            <p v-if="picker.startDate !==null && picker.endDate !==null">{{ FormatDate(dateRange.startDate) }} - {{ FormatDate(picker.endDate) }}</p>
                            <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>

                        </template>
                    </date-range-picker>
                </div>
                    <b-form-textarea
                            id="input-1"
                            v-model=leaveform.reason
                            type="text"
                            class="border form-group"
                            placeholder="Reason for leave"

                            required
                    ></b-form-textarea>


                <b-button type="submit" variant="primary" class="btn-block">Apply</b-button>

            </form>
        </b-modal>
        <b-modal ref="editprofile" id="modal-3" hide-footer hide-header static>
            <h2 class="text-center text-primary">Update profile</h2>
            <hr/>
            <form @submit.prevent="Editprofile" >
                <b-form-group
                        id="input-group-1"
                        label="Profile image"
                        label-for="input-1"
                >
                <fileuploader></fileuploader>
                </b-form-group>
                <hr/>
                <b-form-group
                        id="input-group-1"
                        label="Email address:"
                        label-for="input-1"
                >
                    <b-form-input
                            id="input-1"
                            v-model="useredit.email"
                            type="email"
                            :placeholder=userData.email

                    ></b-form-input>
                </b-form-group>
                <b-form-group
                        id="input-group-1"

                        label-for="input-1"
                        label="Change your full names"
                >
                    <b-form-input
                            id="input-1"
                            v-model=useredit.full_name
                            type="text"
                            class="border form-group"
                            :placeholder=userData.full_name

                    ></b-form-input>


                </b-form-group>

                <b-button type="submit" variant="primary" class="btn-block">Save</b-button>

            </form>
        </b-modal>
        <b-modal ref="editPhoneNumber" id="change-phone-number" hide-footer hide-header static>
            <h2 class="text-center text-primary">Phone number</h2>
            <hr/>
            <p>Please note that for any M-pesa transaction this is the number we will use. It can only be active after 36hrs on change</p>
            <hr />
            <form @submit.prevent="updatePhoneNumber" >
                <vue-tel-input v-on:validate="validatePhoneNumber" v-model="phoneNumber">
                </vue-tel-input>
                <div class="py-2">
                    <b-button type="submit" variant="primary" class="btn-block">Submit</b-button>
                </div>


            </form>
        </b-modal>
        <b-modal ref="defaultRouteModal" id="change-default-route" hide-footer hide-header static @show="loadLandingPageOptions">
            <h2 class="text-center text-primary">Set My Home Page</h2>
            <hr/>
            <p class="text-muted">This page will load automatically when you login or tap the Home icon.</p>
            <hr />
            <form @submit.prevent="updateDefaultRoute">
                <div v-if="loadingLandingOptions" class="text-center py-3">
                    <b-spinner small /> Loading options…
                </div>
                <select v-else class="form-control" v-model="defaultRoute">
                    <option :value="null">— Select page —</option>
                    <option v-for="opt in landingPageOptions" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                    </option>
                </select>
                <div class="py-2">
                    <b-button type="submit" variant="primary" class="btn-block" :disabled="loadingLandingOptions">Save</b-button>
                </div>
            </form>
        </b-modal>

    </div>
</template>

<script>
import { downloadFile } from '../services/pdfDownload';
    import format from 'date-fns/format'

    import { mapGetters } from "vuex";
    import moment from 'moment'
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";


    export default {
        name: "profile",
        components:{

            DateRangePicker
        },
        data(){
            return {
                salaryAdvance: '',
                userData: {},
                phoneNumber:'',
                validPhoneMessage:'',
                defaultRoute: null,
                landingPageOptions: [],
                loadingLandingOptions: false,
                orderstable: {
                    fields: [
                        'index',
                        {
                            key: 'order',
                            sortable: true
                        },
                        {
                            key: 'amount',
                            sortable: true
                        },
                        {
                            key: 'date',
                            sortable: true
                        },
                    ],
                    items: [],
                    perPage: 10,
                    currentPage: 1,
                },
                deductionsTable: {
                    fields: [
                        'index',
                        {
                            key: 'deduction',
                            sortable: true
                        },
                        {
                            key: 'amount',
                            sortable: true
                        },
                        {
                            key: 'recurring',
                            sortable: true
                        },
                        {
                            key: 'action',
                            sortable: true
                        },
                    ],
                    items: [],
                },
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                useredit:{
                    full_name:'',
                    email:''
                },
                advanceform:{
                    amount:'',
                    reason:'',
                },
                leaveform:{
                    daterange:'',
                    reason:'',
                },
                dateFormat: 'yyyy-mm-dd',
                dateOne: '',
                dateTwo: '',
                ordersamount: '',
                leavetable:{
                    fields:[
                        "index",
                        {key:"from",sortable:true},
                        {key:"to",sortable:true},
                        {key:"reason",sortable:true},
                        {key:"status",sortable:true},
                    ],
                    items:[],

                },
                salaryadvtable:{
                    fields:[
                        "index",
                        {key:"amount",sortable:true},
                        {key:"date",sortable:true},
                        {key:"status",sortable:true},
                    ],
                    items:[],
                },
                autoApply:true,
                employeeProfile: {
                    deductionSum:0,

                    users:{
                        orders:[],
                    },
                    earnings: {},

                },
                payslipData: {
                periods: [],
                selectedPeriod: null,
                loading: false,
            },



            }
        },
        computed: {
            rowsOrders() {
                return this.orderstable.items.length
            },
            filteredEmployees() {
                 return this.items.filter(item => {

                     const itemName = item.name ? item.name.toLowerCase() : '';
                     return itemName.includes(this.searchemployee.toLowerCase());
                 });
         },
            ...mapGetters(['userDetails'])

        },
        mounted(){

          this.GetEmployeeData()
          this.phoneNumber = this.userDetails.phone
        },
        methods:{
            FormatDate(date)
            {
                let finaldate =  moment(date).format('DD-MMM-YYYY');
                return finaldate;
            },
          GetEmployeeData()
          {
                // Owners/admins without an employee record (or a not-yet-loaded user)
                // have no employee sales or payroll to show here.
                if (!this.userDetails || !this.userDetails.employee || !this.userDetails.employee.id) {
                    return
                }

                axios.get('/api/employee/details', {

                        params: {
                            employee_id: this.userDetails.employee.id,
                            user_id: this.userDetails.id,
                            startDate: this.dateRange.startDate,
                            endDate: this.dateRange.endDate,

                        }
                    })
                    .then(result => {
                        this.employee_id = result.data.id

                        const employeeUserProfile = result.data.users
                        this.employeeProfile = result.data;


                     //   this.userPermissions.selectedPermissions =  (employeeUserProfile.permissions) ? employeeUserProfile.permissions.map(permission => permission.name) : []
                        // console.log(employeeUserProfile)
                        let ordersData = []
                        $.each(this.employeeProfile.users.orders, function(key, value) {
                            ordersData.push({
                                order: value.order,
                                date: moment(value.created_at).format('HH:mm DD-MM-YYYY'),
                                amount: value.total_amount
                            })
                        });
                        this.orderstable.items = ordersData;

                        let totaldeductions = [];
                        let totalDeductionsTable = [];
                        $.each(this.employeeProfile.users.deductions, function(key, value) {
                            totaldeductions.push(value.amount);
                            let recur = (value.recurring === 1) ? 'True' : 'Once';
                            totalDeductionsTable.push({
                                deduction: value.deduction,
                                amount: value.amount,
                                recurring: recur,
                                deduction_id: value.id
                            })
                        });
                        this.deductionsTable.items = totalDeductionsTable;
                        this.employeeProfile.deductionSum = totaldeductions.reduce(function(a, b) {
                            return a + b;
                        }, 0);
                        // this.fillData();

                    });

          },
            isToday(date) {

                return moment(date).format("dddd, MMMM Do YYYY, h:mm:ss a")
            },
            SaApply()
            {

                axios.post('/api/employee-salaryadvance',{amount:this.advanceform.amount,reason:this.advanceform.reason})
                    .then(result => {



                            this.$refs['salaryadvancemodal'].hide();
                            this.$toasts.push({
                                type: result.data.type,
                                message: result.data.message,
                            });
                        this.$refs['salaryadvancemodal'].hide();
                            this.GetEmployeeData()



                    });
            },
            formatDates(dateOne, dateTwo) {
                let formattedDates = ''
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' | ' + format(dateTwo, this.dateFormat)
                }
                this.leaveform.daterange = formattedDates;
                return formattedDates
            },
            leaveApply(){

                axios.post('/api/employee-leaveapply',{daterange:this.formatDates(this.dateRange.startDate,this.dateRange.endDate),reason:this.leaveform.reason})
                    .then(result => {
                            this.$refs['leavemodal'].hide();
                            this.$toasts.push({
                                type: result.data.type,
                                message: result.data.message,
                            });

                    });
            },
            validatePhoneNumber(phoneNumber) {
               this.validPhoneMessage = (phoneNumber.valid) ? '' : "Enter a valid phone number"
            },
            Editprofile(){

                let imagefilename = document.getElementById('filename').value;

                axios.post('/api/employee-edit',{email:this.useredit.email,fullname:this.useredit.full_name,profileimage:imagefilename})
                    .then(result => {


                        if(result.data.status === 200) {
                            this.$refs['editprofile'].hide();
                            this.$toasts.push({
                                type: 'success',
                                message: result.data.message,
                            });
                            this.GetEmployeeData()
                        }
                        else {
                            this.$toasts.push({
                                type: 'error',

                                message: result.data.message,
                            });
                            this.$refs['editprofile'].hide();
                        }


                    });
            },
            updatePhoneNumber()
            {
                axios.post('/api/update-user-phone-number',{phoneNumber:this.phoneNumber}).then(results=>{
                    if(results.status===200)
                    {
                        this.$toasts.push({
                            type:"success",
                            message:"Phone number updated successfully"
                        })
                        this.$refs.editPhoneNumber.hide()
                    }
                }).catch()
            },
            async loadLandingPageOptions() {
                this.loadingLandingOptions = true
                try {
                    const { data } = await axios.get('/api/landing-page-options')
                    this.landingPageOptions = data
                    // Pre-select user's current default
                    this.defaultRoute = this.userDetails.default_route || null
                } catch {
                    this.$toasts.push({ type: 'error', message: 'Failed to load page options.' })
                } finally {
                    this.loadingLandingOptions = false
                }
            },

            async updateDefaultRoute() {
                try {
                    const { data } = await axios.post('/api/update-default-route', { route: this.defaultRoute })
                    // Update Vuex so BottomMenu home link and any other consumer reflects the change immediately
                    this.$store.commit('addUserDetails', data)
                    this.$toasts.push({ type: 'success', message: 'Default page updated successfully.' })
                    this.$refs.defaultRouteModal.hide()
                } catch (err) {
                    const msg = err.response?.data?.message || 'Failed to update default page.'
                    this.$toasts.push({ type: 'error', message: msg })
                }
            },

    fetchPayslipPeriods() {
        if (!this.userDetails || !this.userDetails.employee || !this.userDetails.employee.id) {
            this.payslipData.loading = false;
            return;
        }
        this.payslipData.loading = true;

        axios.get(`/api/payslip/${this.userDetails.employee.id}`)
            .then(response => {
                if (response.data.status === 'success') {
                    this.payslipData.periods = response.data.data;

                    if (this.payslipData.periods.length === 0) {
                        this.$toasts.push({
                            type: "info",
                            message: "No payslips available for this employee."
                        });
                    } else {
                        this.$refs.payslipModal.show();
                    }
                }
            })
            .catch(() => {
                this.$toasts.push({
                    type: "error",
                    message: "Failed to fetch payslips."
                });
            })
            .finally(() => {
                this.payslipData.loading = false;
            });
    },

    downloadPayslip() {
        if (!this.payslipData.selectedPeriod) {
            this.$toasts.push({
                type: "warning",
                message: "Please select a payslip period first."
            });
            return;
        }

        const payslipId = this.payslipData.selectedPeriod;
        downloadFile(`/api/payslip/download/${payslipId}`, 'payslip.pdf')
            .catch(() => this.$toasts.push({ type: 'error', message: 'Could not download the payslip. Please try again.' }));
    }


        },
    }
</script>

<style scoped>

</style>
